import { Action } from 'helpers/action-helpers';
import { AuditLog } from 'types/audit-log';

export const WRITE_AUDIT_LOG = 'WriteAuditLogAction';

export class WriteAuditLogAction extends Action {
  constructor(public auditLog: AuditLog) {
    super(WRITE_AUDIT_LOG);
  }
}


// WEBPACK FOOTER //
// ./src/components/audit-logs/actions.ts